var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{on:{"click":_vm.increment}},[_vm._v(" Count is: "+_vm._s(_vm.state.count)+", double is: "+_vm._s(_vm.state.double)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }